export const categories = [
  { name: "恋爱", slug: "romance", icon: "ri-heart-line", description: "甜到心里的恋爱故事，少女心炸裂的浪漫篇章" },
  { name: "奇幻", slug: "fantasy", icon: "ri-magic-line", description: "穿越异世界、魔法冒险的奇幻旅程" },
  { name: "悬疑", slug: "mystery", icon: "ri-search-eye-line", description: "烧脑推理，层层反转的悬疑故事" },
  { name: "古风", slug: "historical", icon: "ri-ancient-gate-line", description: "唯美古风，仙侠江湖的爱恨情仇" },
  { name: "都市", slug: "urban", icon: "ri-building-line", description: "现代都市生活中的温情与成长" },
  { name: "搞笑", slug: "comedy", icon: "ri-emotion-laugh-line", description: "笑到停不下来的欢乐日常" },
  { name: "动作", slug: "action", icon: "ri-flashlight-line", description: "热血战斗，燃到爆炸的激斗场面" },
  { name: "恐怖", slug: "horror", icon: "ri-ghost-line", description: "胆小鬼慎入！令人毛骨悚然的恐怖故事" },
];

export const categorySlugMap: Record<string, string> = {};
categories.forEach((c) => { categorySlugMap[c.slug] = c.name; });